
export class Shop {

}


// WEBPACK FOOTER //
// ./src/app/app.shop.ts